import { onUnmounted } from "vue";

/**
 * Closes a combobox shortly after blur if focus moved outside the container.
 *
 * @param {Object} options
 * @param {import('vue').Ref<HTMLElement|null>} options.containerRef
 * @param {Function} options.close
 * @param {number} options.delay
 * @returns {{ handleBlur: () => void }}
 */
export function useComboboxBlur({ containerRef, close, delay = 150 }) {
  let timerId = null;

  function clearBlurTimer() {
    if (timerId !== null) {
      clearTimeout(timerId);
      timerId = null;
    }
  }

  function handleBlur() {
    clearBlurTimer();
    timerId = setTimeout(() => {
      timerId = null;
      if (!containerRef.value?.contains(document.activeElement)) {
        close();
      }
    }, delay);
  }

  onUnmounted(clearBlurTimer);

  return { handleBlur };
}
